var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-newsletter-banner" },
    [
      _c(
        "rb-banner",
        _vm._b(
          {},
          "rb-banner",
          Object.assign({}, _vm.$props, _vm.$attrs),
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }